import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { TitleProvider } from '../context/TitleContext';
import '../styles/dashboard-layout.scss';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Detect screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      // On mobile, open/close sidebar overlay
      setSidebarOpen(!sidebarOpen);
    } else {
      // On desktop, collapse/expand sidebar
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  return (
    <TitleProvider>
      <div className={`wrapper ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Sidebar 
          isOpen={sidebarOpen} 
          isCollapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar} 
        />
        <div className="page-content">
          <Header toggleSidebar={toggleSidebar} />
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
      </div>
    </TitleProvider>
  );
};

export default DashboardLayout;
